import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { TagInput } from '@/shared/ui/tag-input'
import { tagSuggestionsQueryOptions } from '../api/queries'
import { TAG_MAX } from '../model/types'

interface EntityTagsInputProps {
  id?: string
  value: string[]
  onChange: (tags: string[]) => void
  disabled?: boolean
  placeholder?: string
  'aria-invalid'?: boolean
  'aria-describedby'?: string
}

const SUGGEST_DEBOUNCE_MS = 300

// Поле тегов сущности: TagInput + серверные подсказки (дебаунс, популярные выше).
// Само не пишет — value/onChange у родителя, запись идёт через useSetEntityTags.
export function EntityTagsInput({ value, onChange, ...rest }: EntityTagsInputProps) {
  const [query, setQuery] = useState('')
  const [debounced, setDebounced] = useState('')

  useEffect(() => {
    const t = setTimeout(() => setDebounced(query.trim()), SUGGEST_DEBOUNCE_MS)
    return () => clearTimeout(t)
  }, [query])

  const suggestions = useQuery(tagSuggestionsQueryOptions(debounced))

  return (
    <TagInput
      {...rest}
      value={value}
      onChange={onChange}
      query={query}
      onQueryChange={setQuery}
      suggestions={(suggestions.data ?? []).map((s) => s.name)}
      placeholder={rest.placeholder ?? 'Добавить тег…'}
      maxTags={TAG_MAX}
    />
  )
}
